export default [
    {
        "code": "AF",
        "name": "Afghanistan"
    },
    {
        "code": "AL",
        "name": "Albania"
    },
    {
        "code": "DZ",
        "name": "Algeria"
    },
    {
        "code": "AS",
        "name": "American Samoa"
    },
    {
        "code": "VI",
        "name": "U.S. Virgin Islands"
    },
    {
        "code": "AD",
        "name": "Andorra"
    },
    {
        "code": "AO",
        "name": "Angola"
    },
    {
        "code": "AI",
        "name": "Anquilla"
    },
    {
        "code": "AQ",
        "name": "Antarctica"
    },
    {
        "code": "AG",
        "name": "Antigua and Barbuda"
    },
    {
        "code": "AR",
        "name": "Argentina"
    },
    {
        "code": "AM",
        "name": "Armenia"
    },
    {
        "code": "AW",
        "name": "Aruba"
    },
    {
        "code": "AU",
        "name": "Australia"
    },
    {
        "code": "AZ",
        "name": "Azerbaijan"
    },
    {
        "code": "BS",
        "name": "Bahamas"
    },
    {
        "code": "BH",
        "name": "Bahrain"
    },
    {
        "code": "BD",
        "name": "Bangladesh"
    },
    {
        "code": "BB",
        "name": "Barbados"
    },
    {
        "code": "BE",
        "name": "Belgium"
    },
    {
        "code": "BZ",
        "name": "Belize"
    },
    {
        "code": "BJ",
        "name": "Benin"
    },
    {
        "code": "BM",
        "name": "Bermuda"
    },
    {
        "code": "BT",
        "name": "Bhutan"
    },
    {
        "code": "BO",
        "name": "Bolivia"
    },
    {
        "code": "BA",
        "name": "Bosnia-Herzegovina"
    },
    {
        "code": "BW",
        "name": "Botswana"
    },
    {
        "code": "BV",
        "name": "Bouvet Island"
    },
    {
        "code": "BR",
        "name": "Brazil"
    },
    {
        "code": "VG",
        "name": "British Virgin Islands"
    },
    {
        "code": "BN",
        "name": "Brunei"
    },
    {
        "code": "BG",
        "name": "Bulgaria"
    },
    {
        "code": "BF",
        "name": "Burkina Faso"
    },
    {
        "code": "BI",
        "name": "Burundi"
    },
    {
        "code": "CA",
        "name": "Canada"
    },
    {
        "code": "KY",
        "name": "Cayman Islands"
    },
    {
        "code": "IO",
        "name": "Chagos Archipelago"
    },
    {
        "code": "CL",
        "name": "Chile"
    },
    {
        "code": "CX",
        "name": "Christmas Island"
    },
    {
        "code": "CC",
        "name": "Cocosøyene"
    },
    {
        "code": "CO",
        "name": "Colombia"
    },
    {
        "code": "KM",
        "name": "Comores"
    },
    {
        "code": "CR",
        "name": "Costa Rica"
    },
    {
        "code": "CU",
        "name": "Cuba"
    },
    {
        "code": "DK",
        "name": "Denmark"
    },
    {
        "code": "DJ",
        "name": "Djibouti"
    },
    {
        "code": "DM",
        "name": "Dominica"
    },
    {
        "code": "DO",
        "name": "Dominican Republic"
    },
    {
        "code": "EC",
        "name": "Ecuador"
    },
    {
        "code": "EG",
        "name": "Egypt"
    },
    {
        "code": "GQ",
        "name": "Equatorial Guinea"
    },
    {
        "code": "SV",
        "name": "El Salvador"
    },
    {
        "code": "CI",
        "name": "Ivory Coast"
    },
    {
        "code": "ER",
        "name": "Eritrea"
    },
    {
        "code": "EE",
        "name": "Estonia"
    },
    {
        "code": "ET",
        "name": "Ethiopia"
    },
    {
        "code": "FK",
        "name": "Falkland Islands"
    },
    {
        "code": "FJ",
        "name": "Fiji"
    },
    {
        "code": "PH",
        "name": "Philippines"
    },
    {
        "code": "FI",
        "name": "Finland"
    },
    {
        "code": "AE",
        "name": "United Arab Emirates"
    },
    {
        "code": "FR",
        "name": "France"
    },
    {
        "code": "GF",
        "name": "French Guiana"
    },
    {
        "code": "PF",
        "name": "French Polynesia"
    },
    {
        "code": "TF",
        "name": "French Southern Territories"
    },
    {
        "code": "FO",
        "name": "Faroe Islands"
    },
    {
        "code": "GA",
        "name": "Gabon"
    },
    {
        "code": "GM",
        "name": "Gambia"
    },
    {
        "code": "GE",
        "name": "Georgia"
    },
    {
        "code": "GH",
        "name": "Ghana"
    },
    {
        "code": "GI",
        "name": "Gibraltar"
    },
    {
        "code": "GD",
        "name": "Grenada"
    },
    {
        "code": "GL",
        "name": "Greenland"
    },
    {
        "code": "GP",
        "name": "Guadeloupe"
    },
    {
        "code": "GU",
        "name": "Guam"
    },
    {
        "code": "GT",
        "name": "Guatemala"
    },
    {
        "code": "GG",
        "name": "Guernsey Channel Islands"
    },
    {
        "code": "GN",
        "name": "Guinea"
    },
    {
        "code": "GW",
        "name": "Guinea-Bissau"
    },
    {
        "code": "GY",
        "name": "Guyana"
    },
    {
        "code": "HT",
        "name": "Haiti"
    },
    {
        "code": "HM",
        "name": "Heard and Mc Donald Islands"
    },
    {
        "code": "GR",
        "name": "Greece"
    },
    {
        "code": "CK",
        "name": "Herveyøyene (Cook Islands)"
    },
    {
        "code": "HN",
        "name": "Honduras"
    },
    {
        "code": "HK",
        "name": "Hong Kong"
    },
    {
        "code": "BY",
        "name": "Belarus"
    },
    {
        "code": "IN",
        "name": "India"
    },
    {
        "code": "ID",
        "name": "Indonesia"
    },
    {
        "code": "IQ",
        "name": "Iraq"
    },
    {
        "code": "IR",
        "name": "Iran"
    },
    {
        "code": "IE",
        "name": "Ireland"
    },
    {
        "code": "IS",
        "name": "Island"
    },
    {
        "code": "IM",
        "name": "Isle of Man"
    },
    {
        "code": "IL",
        "name": "Israel"
    },
    {
        "code": "IT",
        "name": "Italy"
    },
    {
        "code": "JM",
        "name": "Jamaica"
    },
    {
        "code": "JP",
        "name": "Japan"
    },
    {
        "code": "JE",
        "name": "Jersey"
    },
    {
        "code": "JO",
        "name": "Jordan"
    },
    {
        "code": "CM",
        "name": "Cameroon"
    },
    {
        "code": "KH",
        "name": "Cambodia"
    },
    {
        "code": "CV",
        "name": "Cape Verde"
    },
    {
        "code": "KZ",
        "name": "Kazakhstan"
    },
    {
        "code": "KE",
        "name": "Kenya"
    },
    {
        "code": "CN",
        "name": "China"
    },
    {
        "code": "KI",
        "name": "Kiribati"
    },
    {
        "code": "CG",
        "name": "Congo"
    },
    {
        "code": "HR",
        "name": "Croatia"
    },
    {
        "code": "KW",
        "name": "Kuwait"
    },
    {
        "code": "CY",
        "name": "Cyprus"
    },
    {
        "code": "KG",
        "name": "Kyrgyzstan"
    },
    {
        "code": "LA",
        "name": "Laos"
    },
    {
        "code": "LV",
        "name": "Latvia"
    },
    {
        "code": "LS",
        "name": "Lesotho"
    },
    {
        "code": "LB",
        "name": "Lebanon"
    },
    {
        "code": "LR",
        "name": "Liberia"
    },
    {
        "code": "LY",
        "name": "Libya"
    },
    {
        "code": "LI",
        "name": "Liechtenstein"
    },
    {
        "code": "LT",
        "name": "Lithuania"
    },
    {
        "code": "LU",
        "name": "Luxembourg"
    },
    {
        "code": "MO",
        "name": "Macau"
    },
    {
        "code": "MG",
        "name": "Madagascar"
    },
    {
        "code": "MK",
        "name": "Macedonia"
    },
    {
        "code": "MW",
        "name": "Malawi"
    },
    {
        "code": "MY",
        "name": "Malaysia"
    },
    {
        "code": "MV",
        "name": "Maldives"
    },
    {
        "code": "ML",
        "name": "Mali"
    },
    {
        "code": "MT",
        "name": "Malta"
    },
    {
        "code": "MA",
        "name": "Morocco"
    },
    {
        "code": "MH",
        "name": "Marshall Islands"
    },
    {
        "code": "MQ",
        "name": "Martinique"
    },
    {
        "code": "MR",
        "name": "Mauritania"
    },
    {
        "code": "MU",
        "name": "Mauritius"
    },
    {
        "code": "YT",
        "name": "Mayotte"
    },
    {
        "code": "MX",
        "name": "Mexico"
    },
    {
        "code": "FM",
        "name": "Micronesia"
    },
    {
        "code": "MD",
        "name": "Moldova"
    },
    {
        "code": "MC",
        "name": "Monaco"
    },
    {
        "code": "MN",
        "name": "Mongolia"
    },
    {
        "code": "ME",
        "name": "Montenegro"
    },
    {
        "code": "MS",
        "name": "Montserrat"
    },
    {
        "code": "MPF",
        "name": "Murder Mariana Islands"
    },
    {
        "code": "MZ",
        "name": "Mozambique"
    },
    {
        "code": "MM",
        "name": "Myanmar"
    },
    {
        "code": "NA",
        "name": "Namibia"
    },
    {
        "code": "NR",
        "name": "Nauru"
    },
    {
        "code": "NL",
        "name": "Netherlands"
    },
    {
        "code": "AN",
        "name": "Netherlands Antilles"
    },
    {
        "code": "NP",
        "name": "Nepal"
    },
    {
        "code": "NZ",
        "name": "New Zealand"
    },
    {
        "code": "NI",
        "name": "Nicaragua"
    },
    {
        "code": "NE",
        "name": "Niger"
    },
    {
        "code": "NG",
        "name": "Nigeria"
    },
    {
        "code": "NU",
        "name": "Niue"
    },
    {
        "code": "KP",
        "name": "North Korea"
    },
    {
        "code": "NF",
        "name": "Nordfolkøya"
    },
    {
        "code": "NO",
        "name": "Norway"
    },
    {
        "code": "NC",
        "name": "New Caledonia"
    },
    {
        "code": "OM",
        "name": "Oman"
    },
    {
        "code": "PK",
        "name": "Pakistan"
    },
    {
        "code": "PW",
        "name": "Palau"
    },
    {
        "code": "PS",
        "name": "Palestine"
    },
    {
        "code": "PA",
        "name": "Panama"
    },
    {
        "code": "PZ",
        "name": "Panama Canal Zone"
    },
    {
        "code": "PG",
        "name": "Papua - New Guinea"
    },
    {
        "code": "PY",
        "name": "Paraguay"
    },
    {
        "code": "PE",
        "name": "Peru"
    },
    {
        "code": "PN",
        "name": "Pitcairn"
    },
    {
        "code": "PL",
        "name": "Poland"
    },
    {
        "code": "PT",
        "name": "Portugal"
    },
    {
        "code": "PR",
        "name": "Puerto Rico"
    },
    {
        "code": "QA",
        "name": "Qatar"
    },
    {
        "code": "RE",
        "name": "Reunion"
    },
    {
        "code": "RO",
        "name": "Romania"
    },
    {
        "code": "RU",
        "name": "Russia"
    },
    {
        "code": "RW",
        "name": "Rwanda"
    },
    {
        "code": "SB",
        "name": "Solomon Islands"
    },
    {
        "code": "WS",
        "name": "Samoa"
    },
    {
        "code": "SM",
        "name": "San Marino"
    },
    {
        "code": "ST",
        "name": "Sao Tome and Principe"
    },
    {
        "code": "SA",
        "name": "Saudi Arabia"
    },
    {
        "code": "SN",
        "name": "Senegal"
    },
    {
        "code": "CF",
        "name": "Sentralafr. Republic"
    },
    {
        "code": "RS",
        "name": "Serbia"
    },
    {
        "code": "SC",
        "name": "Seychelles"
    },
    {
        "code": "SL",
        "name": "Sierra Leone"
    },
    {
        "code": "SG",
        "name": "Singapore"
    },
    {
        "code": "SK",
        "name": "Slovakia"
    },
    {
        "code": "SI",
        "name": "Slovenia"
    },
    {
        "code": "SO",
        "name": "Somalia"
    },
    {
        "code": "ES",
        "name": "Spain"
    },
    {
        "code": "LK",
        "name": "Sri Lanka"
    },
    {
        "code": "KN",
        "name": "St. Christopher - Nevis"
    },
    {
        "code": "SH",
        "name": "St. Helena"
    },
    {
        "code": "LC",
        "name": "St. Lucia"
    },
    {
        "code": "PM",
        "name": "St. Pierre and Miquelon"
    },
    {
        "code": "VC",
        "name": "St. Vincent"
    },
    {
        "code": "GB",
        "name": "Great Britain (UK)"
    },
    {
        "code": "SD",
        "name": "Sudan"
    },
    {
        "code": "SR",
        "name": "Suriname"
    },
    {
        "code": "SJ",
        "name": "Svalbard and Jan Mayen"
    },
    {
        "code": "CH",
        "name": "Switzerland"
    },
    {
        "code": "SE",
        "name": "Sweden"
    },
    {
        "code": "SZ",
        "name": "Swaziland"
    },
    {
        "code": "SY",
        "name": "Syria"
    },
    {
        "code": "ZA",
        "name": "South Africa"
    },
    {
        "code": "GS",
        "name": "South Georgia and S. Sandwich Isl"
    },
    {
        "code": "KR",
        "name": "South Korea"
    },
    {
        "code": "TJ",
        "name": "Tadzjikistan"
    },
    {
        "code": "TW",
        "name": "Taiwan"
    },
    {
        "code": "TZ",
        "name": "Tanzania"
    },
    {
        "code": "TD",
        "name": "chad"
    },
    {
        "code": "TH",
        "name": "Thailand"
    },
    {
        "code": "TP",
        "name": "Timor"
    },
    {
        "code": "TG",
        "name": "Togo"
    },
    {
        "code": "TK",
        "name": "Tokelau"
    },
    {
        "code": "TO",
        "name": "Tonga"
    },
    {
        "code": "TT",
        "name": "Trinidad and Tobago"
    },
    {
        "code": "CZ",
        "name": "Czech Republic"
    },
    {
        "code": "TN",
        "name": "Tunisial"
    },
    {
        "code": "TM",
        "name": "Turkmenistan"
    },
    {
        "code": "TC",
        "name": "Turks and Caicos Islands"
    },
    {
        "code": "TV",
        "name": "Tuvalu"
    },
    {
        "code": "TR",
        "name": "Turkey"
    },
    {
        "code": "DE",
        "name": "Germany"
    },
    {
        "code": "UG",
        "name": "Uganda"
    },
    {
        "code": "UA",
        "name": "Ukraine"
    },
    {
        "code": "HU",
        "name": "Hungary"
    },
    {
        "code": "UY",
        "name": "Uruguay"
    },
    {
        "code": "UM",
        "name": "U.S.. Minor Outlet. Isl."
    },
    {
        "code": "US",
        "name": "USA"
    },
    {
        "code": "UZ",
        "name": "Uzbekistan"
    },
    {
        "code": "VU",
        "name": "Vanuatu"
    },
    {
        "code": "VA",
        "name": "Vatican City"
    },
    {
        "code": "VE",
        "name": "Venezuela"
    },
    {
        "code": "EH",
        "name": "Western Sahara"
    },
    {
        "code": "VN",
        "name": "Vietnam"
    },
    {
        "code": "WF",
        "name": "Wallis and Futuna"
    },
    {
        "code": "YE",
        "name": "Yemen"
    },
    {
        "code": "ZR",
        "name": "Zaire"
    },
    {
        "code": "ZM",
        "name": "Zambia"
    },
    {
        "code": "ZW",
        "name": "Zimbabwe"
    },
    {
        "code": "AT",
        "name": "Austria"
    },
]

